module.exports = "./../fonts/open-sans-v34-latin-800.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/open-sans-v34-latin-800.eot
// module id = 118
// module chunks = 0